import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  Wrench,
  Clock3,
  RefreshCw,
  ArrowLeft,
  ShieldCheck,
} from "lucide-react";

export default function Maintenance() {
  return (
    <div className="min-h-screen bg-cream">
      <div className="mx-auto flex min-h-screen max-w-7xl items-center justify-center px-6 py-16 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
          className="w-full max-w-2xl rounded-[2rem] border border-ink/10 bg-white p-8 shadow-sm md:p-12"
          data-testid="maintenance-page"
        >
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-peach">
            <Wrench
              size={40}
              className="text-hotpink"
              strokeWidth={2.4}
            />
          </div>

          <p className="mt-8 text-center text-xs font-bold uppercase tracking-[0.25em] text-hotpink">
            Scheduled Maintenance
          </p>

          <h1 className="mt-3 text-center font-display text-4xl tracking-tighter md:text-5xl">
            We'll be back
            <br />
            very soon.
          </h1>

          <p className="mx-auto mt-5 max-w-xl text-center text-ink/65">
            Checkout DM is currently undergoing maintenance or a platform
            upgrade. We are working to restore all services as quickly as
            possible.
          </p>

          <div className="mt-10 rounded-3xl border border-ink/10 bg-cream p-6">
            <p className="text-sm font-semibold text-ink">
              During maintenance
            </p>

            <ul className="mt-4 space-y-3 text-sm text-ink/65">
              <li className="flex gap-3">
                <Clock3
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                Instagram automations may be temporarily paused.
              </li>

              <li className="flex gap-3">
                <ShieldCheck
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                Your customer data and orders remain completely safe.
              </li>

              <li className="flex gap-3">
                <RefreshCw
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                Simply refresh this page in a few minutes.
              </li>
            </ul>
          </div>

          <div className="mt-10 flex flex-col gap-4 md:flex-row">
            <button
              onClick={() => window.location.reload()}
              data-testid="maintenance-refresh-btn"
              className="cta-glow inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-sunset-gradient px-6 py-3 text-sm font-semibold text-white"
            >
              <RefreshCw size={16} />
              Check Again
            </button>

            <Link
              to="/"
              data-testid="maintenance-home-btn"
              className="inline-flex flex-1 items-center justify-center gap-2 rounded-full border border-ink/10 bg-white px-6 py-3 text-sm font-semibold text-ink hover:bg-ink/5"
            >
              <ArrowLeft size={16} />
              Home
            </Link>
          </div>

          <div className="mt-8 rounded-2xl bg-mint p-4">
            <p className="font-semibold text-ink">
              We appreciate your patience
            </p>

            <p className="mt-1 text-sm text-ink/65">
              Planned maintenance allows us to improve reliability, security,
              and performance for every merchant using Checkout DM.
            </p>
          </div>

          <p className="mt-8 text-center text-xs text-ink/50">
            Thank you for choosing Checkout DM ❤️
          </p>
        </motion.div>
      </div>
    </div>
  );
}